<script setup>
// O modo TV e Minhas avaliações (o Monitoramento e a Auditoria ficam juntos em
// GestaoPainel.vue): título e o componente da seção.
// Quem não tem o recurso (endereço digitado, favorito antigo) vê o aviso em vez
// de uma tela quebrada; quem decide de verdade é o servidor (404).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import { useRecursos } from '../nexus/recursos';
import ModoTv from './ModoTv.vue';
import MinhasAvaliacoes from './MinhasAvaliacoes.vue';
import messages from './i18n';

const props = defineProps({
  secao: { type: String, required: true },
});

const COMPONENTES = {
  TV: ModoTv,
  MINHAS: MinhasAvaliacoes,
};

const { t } = useI18n({ messages });
const { accountId } = useAccount();
const recursos = useRecursos();

// O recurso que libera cada seção (o mesmo do menu, em useNexusMenu.js).
const RECURSO = {
  TV: 'administrador',
  MINHAS: 'minhas_avaliacoes',
};
const liberada = computed(() =>
  Boolean(recursos.value?.[RECURSO[props.secao] || 'auditoria'])
);
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="px-6">
      <div class="flex items-center w-full h-20 max-w-6xl gap-2 mx-auto">
        <span class="i-lucide-gauge size-5 text-n-slate-11" />
        <span class="text-heading-1 text-n-slate-12">
          {{ t(`NEUXS_GESTAO.PAGINAS.${secao}`) }}
        </span>
      </div>
    </header>
    <main class="flex-1 px-6 overflow-y-auto">
      <div class="w-full max-w-6xl pb-10 mx-auto">
        <div v-if="recursos === null" class="flex justify-center py-10">
          <Spinner />
        </div>
        <p
          v-else-if="!liberada"
          class="p-4 text-sm rounded-xl bg-n-alpha-2 text-n-slate-11"
        >
          {{ t('NEUXS_GESTAO.SEM_ACESSO') }}
        </p>
        <component
          :is="COMPONENTES[secao]"
          v-else
          :key="`${secao}-${accountId}`"
          :account-id="accountId"
        />
      </div>
    </main>
  </section>
</template>
